import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ComboBoxOption } from 'src/app/models/combo-box-option';
import { ProductDistribution } from 'src/app/models/register/product/product-distribution';
import { ProductDistributionDetail } from 'src/app/models/register/product/product-distribution-detail';
import { FileService } from 'src/app/services/file/file.service';
import { ProductService } from 'src/app/services/product/product.service';
import { WorkBook, WorkSheet } from 'xlsx';

@Component({
  selector: 'distribution-direct',
  templateUrl: './distribution-direct.component.html',
  styleUrls: ['./distribution-direct.component.scss'],
})
export class DistributionDirectComponent implements DoCheck, OnInit {
  printBatchRestrictedPrefix: string = '';

  @ViewChild('deliveryWayAutomaticInput')
  deliveryWayDirectInput: FileUpload | null = null;

  @Input()
  InputdeliveryWayDirect: ProductDistribution[] = [];

  selectedDistribution!: ProductDistribution[];

  deliveryWayDirect: any[] = [];

  @Input()
  quantity: string = '0';

  @Input()
  isConfirmed: boolean = false;

  minDate: Date = new Date();

  @Input()
  isLoading: boolean = false;

  printBatchRestrictedPrefixOptions: ComboBoxOption[] = [];

  @Output()
  changed = new EventEmitter<any>();

  @Output()
  changeTotal = new EventEmitter<any>();

  @Input()
  totalValue: number = 0;

  currentTotal: number = 0;

  private differ: IterableDiffer<ProductDistribution>;

  constructor(
    private productService: ProductService,
    private fileService: FileService,
    private confirmationService: ConfirmationService,
    private differs: IterableDiffers,
    private cdr: ChangeDetectorRef
  ) {
    this.differ = this.differs.find([]).create<ProductDistribution>();
  }

  ngOnInit(): void {
    this.currentTotal = this.totalValue;
    if (this.InputdeliveryWayDirect.length > 0) {
      this.InputdeliveryWayDirect.forEach(item => {
        if (
          item.detail &&
          item.detail.deliveryAt != null &&
          !isNaN(new Date(item.detail.deliveryAt).getTime())
        ) {
          item.detail.deliveryAt = this.parseLocalDate(item.detail.deliveryAt);
        } else {
          item.detail.deliveryAt = undefined;
        }

        this.deliveryWayDirect.push(item);
      });
    }
  }

  parseLocalDate(dateStr: Date): Date | undefined {
    if (!dateStr) return undefined;
    const parts = dateStr.toString().split('-');
    if (parts.length !== 3) return undefined;
    const year = Number(parts[0]);
    const month = Number(parts[1]) - 1;
    const day = Number(parts[2]);
    return new Date(year, month, day);
  }

  public download(url: string): void {
    window.location.href = url;
  }

  public filterDeliveryWayDirect(event: any): void {
    this.productService
      .combobox('branches', event.query) //
      .then(
        (data: any): void =>
          (this.printBatchRestrictedPrefixOptions = data.filter(
            (
              item: any
            ): boolean => //
              !this.deliveryWayDirect.some(
                (distribution: any): boolean => distribution['id'] === item['value']
              )
          ))
      );
  }

  handleParsedData(data: { branchCode: string; quantity: number; deliveryAt?: Date }[]) {
    console.log('Dados recebidos da planilha:', data);

    data.forEach(({ branchCode, quantity, deliveryAt }) => {
      this.productService
        .combobox('branches', branchCode)
        .then((resultData: any): void => {
          if (resultData?.length) {
            this.deliveryWayDirect.push({
              detail: {
                id: resultData[0].value,
                label: resultData[0].label,
              },
              quantity,
              ...(deliveryAt && { deliveryAt }), // adiciona só se existir
              checked: true,
            });
          }
        })
        .finally(() => this.onChangeData());
    });
  }

  public removeDeliveryWayDirect(event: any, item: any, i: number): void {
    this.confirmationService.confirm({
      target: event.target!,
      header: 'Confirmação',
      message: 'Deseja realmente remover <strong>' + item.detail.label + '</strong>?',
      icon: 'fa-solid fa-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      defaultFocus: 'reject',
      accept: (): void => {
        this.setOnRemoveItem(i);
      },
      reject: (): void => {
        // reject action
      },
    });
  }

  public deleteSelectedProductionItens(event: any) {
    this.confirmationService.confirm({
      target: event.target!,
      header: 'Confirmação',
      message: `Deseja remover ${this.selectedDistribution.length} linhas da distribuição?`,
      icon: 'fa-solid fa-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      defaultFocus: 'reject',
      accept: (): void => {
        this.selectedDistribution.forEach(item => {
          var idx = this.deliveryWayDirect.findIndex(deliveryItem => deliveryItem.id === item.id);
          this.setOnRemoveItem(idx);
        });
      },
      reject: (): void => {
        // reject action
      },
    });
  }

  get Itens() {
    return this.deliveryWayDirect.filter((item: any) => !item.remove);
  }

  private setOnRemoveItem(index: number) {
    this.deliveryWayDirect[index].remove = true;
    this.onChangeData();
  }

  public deliveryWayCanBeRemoved(item: any): boolean {
    return item.orderItem === undefined || item.orderItem === null || item.orderItem < 1;
  }

  public addDeliveryWayDirect(event: any): void {
    this.deliveryWayDirect.push({
      detail: {
        id: event.value,
        label: event.label,
      } as ProductDistributionDetail,
      quantity: 0,
    } as ProductDistribution);

    setTimeout((): void => {
      this.printBatchRestrictedPrefix = '';
      const input: HTMLInputElement = document.getElementById(
        'print-batch-restricted-prefix2'
      )! as HTMLInputElement;
      input.focus();
    }, 100);
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.deliveryWayDirect);
    if (change) {
      // há mudanças internas no array
      change.forEachAddedItem(record => {
        // console.log('Item adicionado:', record.item);
      });
      change.forEachRemovedItem(record => {
        // console.log('Item removido:', record.item);
      });

      this.cdr.detectChanges();
    }
  }

  onChangeData(): void {
    this.changed.emit(this.deliveryWayDirect);
  }

  onChangeTotal(): void {
    console.log('changed this total');
    this.changeTotal.emit({ type: 'D', total: this.currentTotal });
  }
}
